module.exports = __webpack_public_path__ + "img/favicon.142f4b8.png";